import styled from 'styled-components';

export const EasyAccessWrapper = styled('div')`
  ${({ theme }) => `
    align-items:center;
    display:flex;
    flex-direction:column;
    @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin-top: auto;
        margin-bottom: auto;
    }
  `}
`;

export const EasyAccessInnerWrapper = styled('div')`
  padding-left: 32px;
  padding-right: 32px;
`;

export const CardWrapper = styled('div')`
  ${({ theme }) => `
    width: 100%;
    max-width: ${theme.spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      background:transparent;
      box-shadow:none;
      margin-left: auto;
      margin-right: auto;
    }
  `}
`;

export const WelcomeText = styled('div')`
  ${({ theme }) => `
    color:#2F4E5C;
    font-size:32px;
    text-align:center;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        font-size:24px;
        width: 195px;
        margin-left: auto;
        margin-right: auto;
    }
  `}
`;

export const PageMessage = styled('div')`
  ${({ theme }) => `
    color:#707070;
    font-size:20px;
    text-align:center;
    margin-top:32px;
    max-width: 396px;
    margin-left: auto;
    margin-right: auto;
    line-height: 32px;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        font-size:16px;
        padding-left:20px;
        padding-right:20px;
        line-height: normal;
    }
  `}
`;

export const ClickHere = styled('span')`
  ${({ theme }) => `
    color:#2DBFF3;
    cursor:pointer;
    position:relative;
    &::before {
        content: "";
        position: absolute;
        cursor:pointer;
        width: 100px;
        height: 70px;
        left: -12px;
        top: -23px;
    }
    @media screen and (max-width: ${theme.breakpoint.sm}) {

    }
  `}
`;

export const DescriptionText = styled('div')`
  ${({ theme }) => `
    color:#707070;
    font-size:16px;
    text-align:center;
    width:286px;
    margin-top:32px;
    margin-left:auto;
    margin-right:auto;
    margin-bottom: 30px;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        font-size:14px;
    }
  `}
`;

export const FBWrapper = styled('div')`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-top:32px;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
        margin-top:40px;
    }
  `}
`;

export const StepperWrapper = styled('div')`
  ${({ theme }) => `
    height:54px;
    width:100%;
    padding-left:16px;
    padding-right:16px;
    @media screen and (min-width: ${theme.breakpoint.sm}) {
        position: absolute;
        top: 0;
    }
  `}
`;

export const LogoWrapper = styled('div')`
  ${({ theme }) => `
    height:54px;
    @media screen and (min-width: ${theme.breakpoint.sm}) {

    }
    & > img  {
      width:128px;
      height: auto;
      @media screen and (min-width: ${theme.breakpoint.sm}) {
          width:140px;
      }
    }
  `}
`;

export const LoginWrapper = styled('div')`
  ${({ theme }) => `
        margin-top:50px;
        @media screen and (min-width: ${theme.breakpoint.sm}) {
            margin-top:0px;
        }

    `}
`;

export const EasyAccessWrapperCard = styled('div')`
  ${({ theme }) => `
        display: flex;
        width:100%;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        @media screen and (max-width: ${theme.breakpoint.sm}) {
            width:auto;
        }
    `}
`;

export const ModalContentWrapper = styled('div')`
  padding: 32px;
  color: #304e5c;
  font-size: 16px;
`;

export const ErrorDiv = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 0px 4px #b11f42;
  padding: 24px;
  color: #b11f42;
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  @media screen and (max-width: ${(props) => props.theme.breakpoint.sm}) {
    width: 250px;
    font-size: 14px;
    padding: 12px 20px;
    margin-top: 0px;
  }
`;
